import { render, staticRenderFns } from "./tmAudioText.vue?vue&type=template&id=b85c1632&"
import script from "./tmAudioText.vue?vue&type=script&lang=js&"
export * from "./tmAudioText.vue?vue&type=script&lang=js&"
import style0 from "./tmAudioText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports